/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobCreatedAtQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobCreatedAtQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobCreatedAtQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobCreatedAtQueryOperator>): PolicyJobCreatedAtQueryOperator {
        let obj = Object.assign(new PolicyJobCreatedAtQueryOperator(), model);
        PolicyJobCreatedAtQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobCreatedAtQueryOperator>): PolicyJobCreatedAtQueryOperator {
        if (!model) return null;
        return PolicyJobCreatedAtQueryOperator.newInstance(<PolicyJobCreatedAtQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobCreatedAtQueryOperator) {
        if (!obj) return;

        models.PolicyJobCreatedAtQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobCreatedAtQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobCreatedAtQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Filter jobs created on or before this date
     */
    start_date: Date;

    /**
     * Filter jobs created on or after this date
     */
    end_date: Date;

}
